import { App, Popconfirm } from "antd";
import { apiMethod } from "api/transaction";
import TableComponent from "components/table";
import PageContainer from "layouts/components/pageContainer";
import { Fragment, useState } from "react";
import { formattedDateTime } from "utils/dateFormat";
import { BrandTransactionStatus } from "utils/enum";
import { CheckOutlined, CheckCircleOutlined } from "@ant-design/icons";
import InvoiceIcon from '../../assets/images/InvoiceIcon.svg'
import moment from "moment";


const TransactionHistory = () => {
  const { message } = App.useApp();
  const [reloadTable, setreloadTable] = useState(0);
  const [loaderInvoice, setLoaderInvoice] = useState(false);


  const calculateCampaignStatus = (campaignCompletedDate?: any) => {
    //.add(60, 'days')
    const paymentDueDate = moment(campaignCompletedDate)
    const currentDate = moment().startOf('day'); // Get the current date at the start of the day
    const daysDifference = paymentDueDate.diff(currentDate, 'days'); // Difference in days between payment due date and today
    if (daysDifference === 60) {
      return `Due in ${daysDifference} days`;
      // return `Payment Due`;
    } else if (daysDifference > 3) {
      return `Due in ${daysDifference} days`;
    } else if (daysDifference > 0 && daysDifference >= 3) {

      return `Overdue ${3 - daysDifference + 1} days`;
    } else if (daysDifference > 0 && daysDifference > 3) {

      return `Overdue on ${paymentDueDate.format('MM/DD/YY')}`;
    } else if (daysDifference === 0) {
      return `${paymentDueDate.format('MM/DD/YY')}`;
    } else {

      return `Overdue on ${paymentDueDate.format('MM/DD/YY')}`;
    }
  };

  // const updatePaymentStatus = async (
  //   id: number,
  //   status: number,
  //   brandId: number,
  //   price: number
  // ) => {
  //   apiMethod
  //     .updatePaymentStatus(id, status, brandId, price)
  //     .then((res: any) => {
  //       message.success("Payment status updated successfully.");
  //       setreloadTable((reloadTable) => reloadTable + 1);
  //     })
  //     .catch((err: any) => { });
  // };


  // const handleGenerateInvoice = (campaignId: string) => {
  //   setLoaderInvoice(true);
  //   const payload = { campaignId };
  //   apiMethod.downloadInvoiceCampaign(payload)
  //     .then(() => {
  //       setLoaderInvoice(false);
  //       message.success("Invoice generated successfully.");
  //       setreloadTable((prev) => prev + 1);
  //     })
  //     .catch(() => setLoaderInvoice(false));
  // };


  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      sorter: true,
      dataType: "text",
      render: (value: string) => {
        return <span> {formattedDateTime(value)}</span>;
      },
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      sorter: true,
      dataType: "text",
    },
    {
      title: "Brand Name",
      dataIndex: "brandEntityName",
      sorter: false,
      dataType: "text",
    },
    {
      title: "Campaign / Purchase Order",
      dataType: "text",
      render: (value: any, row: any, index: number) => {
        return (
          <div>
            {row?.status === 13 ? 'Manually settled the remaining balance.' :
              row?.status === 14 ? 'Manually adjusted the outstanding balance for the campaign.' :
                row?.campaign?.title ? row?.campaign?.title : "Purchase Order"}
          </div>
        )
      }
    },
    {
      title: "Daps",
      dataIndex: "daps",
      sorter: true,
      dataType: "text",
    },
    {
      title: "Amount ($)",
      dataIndex: "amount",
      sorter: true,
      dataType: "text",
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (value: any, row: any, index: number) => {
        console.log("row", row);
        console.log("value", value);
        // ((row.invoice === 0 && value === 4 && row?.type === 3) || (value === 13 && row?.type === 3) || (value === 14 && row?.type === 3))
        return (
          <Fragment>
            {
              value === 1 ?
                <span className="green-color">Completed</span>
                : value === 2 ?
                  <span className="yellow-color">Continue</span>
                  : value === 3 ?
                    <span className="yellow-color">In Progress</span>
                    :
                    value === 5 ?
                      <span className="purple-color">Scheduled</span>
                      :
                      value === 12 ?
                        <span className="purple-color">Testing</span>
                        :
                        ((row.invoice === 0 && value === 4 && row?.type === 3) || (value === 13 && row?.type === 3) || (value === 14 && row?.type === 3)) ?
                          <span className="green-color">Completed</span>
                          :
                          [4, 6, 7, 8]?.includes(value) ?
                            <span className="notInvited text-start">{row?.dueDate ? calculateCampaignStatus(moment(row?.dueDate)) : calculateCampaignStatus(moment(row?.campaign?.completedAt).add(60, 'days'))}</span>
                            : value === 9 ? <span className="green-color">Paid</span> : value === 10 ? "Invoice Updated" : value === 11 ? 'Invoice cancelled' : ''
            }

          </Fragment>
        );
      },
    },
    {
      title: "Download Invoice",
      dataIndex: "amount",
      sorter: true,
      dataType: "text",
      render: (value: any, row: any, index: number) => {
        return (
          <>
            {(row.invoice === 1 && row.status === 4 && row?.type === 3) && ([4, 6, 7, 8, 9, 10, 11].includes(row.status) && !row.pdfPath)
              && Number(String(row?.amount)?.replace(/,/g, "")) > 0
              && (row.status !== 12) && (
                <button
                  className="genrate_invoice_btn"
                  onClick={() => {
                    setLoaderInvoice(true);
                    const payload = { campaignId: row?.campaignId };
                    apiMethod.downloadInvoiceCampaign(payload)
                      .then(() => {
                        setLoaderInvoice(false);
                        message.success("Invoice generated successfully.");
                        setreloadTable((prev) => prev + 1);
                      })
                      .catch(() => setLoaderInvoice(false));
                  }}
                >
                  Generate Invoice
                </button>
              )}
            {[1, 4, 6, 7, 8, 9, 10, 11].includes(row.status) && row.pdfPath && (
              <img
                src={InvoiceIcon}
                alt="Invoice"
                className="invoice-icon"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  let fileName = row.pdfPath?.split("/")[row.pdfPath?.split("/")?.length - 1]
                  const a = document.createElement("a");
                  a.setAttribute("href", row.pdfPath);
                  a.setAttribute("download", `${fileName}.csv`);
                  a.click();
                }}
              />
            )}
          </>
        )
      }
    },
  ];

  return (
    <PageContainer title={"Transaction History"}>
      <TableComponent
        apiMethod={apiMethod}
        apiKeyNames={{ list: "list" }}
        columns={columns}
        reloadTable={reloadTable}
        otherGetDataFunc={(obj: any) => {
          //  obj["type"] = 1;
          return obj;
        }}
        customAction={true}
        isTransactionHistory={true}
      />
    </PageContainer>
  );
};

export default TransactionHistory;
